// opervex-frontend/src/routes/humanResourcesRoutes.js

import Employee from "../pages/HumanResources/Employee";
import Roles from "../pages/HumanResources/Roles";
import Sectors from "../pages/HumanResources/Sectors";
import Teams from "../pages/HumanResources/Teams";
import Integrations from "../pages/HumanResources/Integrations";

const humanResourcesRoutes = [
  // Employee
  { path: "HumanResources/Employee", private: true, component: <Employee />, role: "EMPLOYEE" },
  { path: "HumanResources/Employee/:id", private: true, component: <Employee />, role: "EMPLOYEE" },

  // Roles
  { path: "HumanResources/Roles", private: true, component: <Roles />, role: "ROLE_EMPLOYEE" },
  { path: "HumanResources/Roles/:id", private: true, component: <Roles />, role: "ROLE_EMPLOYEE" },

  // Sectors
  { path: "HumanResources/Sectors", private: true, component: <Sectors />, role: "EMPLOYEE_SECTOR" },
  { path: "HumanResources/Sectors/:id", private: true, component: <Sectors />, role: "EMPLOYEE_SECTOR" },

  // Teams
  { path: "HumanResources/Teams", private: true, component: <Teams />, role: "EMPLOYEE_TEAM" },
  { path: "HumanResources/Teams/:id", private: true, component: <Teams />, role: "EMPLOYEE_TEAM" },

  // Integrations
  { path: "HumanResources/Integrations", private: true, component: <Integrations />, role: "HR_INTEGRATION" },
];

export default humanResourcesRoutes;
